(() => {
/* Wild Gainz comparison column switcher.
   Progressive enhancement: without this script the table keeps its
   horizontal scroll on phones. With it, phones show one comparison column
   at a time with previous and next arrows; desktop is untouched, the
   switching CSS only applies below 750px. */

if (customElements.get('wildgainz-comparison')) return;

class WildgainzComparison extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;

    this.switcher = this.querySelector('[data-comparison-switcher]');
    this.label = this.querySelector('[data-comparison-label]');
    this.logo = this.querySelector('[data-comparison-logo]');
    this.prev = this.querySelector('[data-comparison-prev]');
    this.next = this.querySelector('[data-comparison-next]');
    this.headers = Array.from(this.querySelectorAll('thead [data-comparison-col]'));
    this.cells = Array.from(this.querySelectorAll('[data-comparison-col]'));
    if (!this.switcher || this.headers.length === 0) return;

    this.count = this.headers.length;
    // The brand column is whichever header carries data-comparison-brand.
    // The homepage table marks its first column; the versus table marks
    // whichever side the merchant put Wild Gainz on.
    const brand = this.headers.findIndex((header) => header.hasAttribute('data-comparison-brand'));
    this.brandIndex = brand === -1 ? 0 : brand;
    this.setAttribute('data-enhanced', '');
    this.switcher.removeAttribute('hidden');

    if (this.prev) this.prev.addEventListener('click', () => this.select(this.index - 1));
    if (this.next) this.next.addEventListener('click', () => this.select(this.index + 1));
    const start = parseInt(this.dataset.comparisonStart, 10);
    this.select(Number.isNaN(start) ? 0 : start);
  }

  select(index) {
    this.index = Math.max(0, Math.min(this.count - 1, index));
    const current = String(this.index);

    this.cells.forEach((cell) => {
      cell.classList.toggle('is-current', cell.dataset.comparisonCol === current);
    });

    // Brand column shows the logo; the name stays in the DOM visually hidden
    // so the live region still announces every switch. Competitor names get
    // a chip instead; each section's stylesheet decides how it looks.
    const isBrand = this.index === this.brandIndex;
    if (this.label) {
      this.label.textContent = this.headers[this.index].textContent.trim();
      this.label.classList.toggle('visually-hidden', isBrand);
      this.label.classList.toggle('is-competitor', !isBrand);
    }
    if (this.logo) this.logo.hidden = !isBrand;
    if (this.prev) this.prev.disabled = this.index === 0;
    if (this.next) this.next.disabled = this.index === this.count - 1;
  }
}

customElements.define('wildgainz-comparison', WildgainzComparison);
})();
